import { createI18n } from 'vue-i18n';
import { mergeAppKitMessages, readStoredLocale, writeStoredLocale } from '@lumi/app-kit';
import { currentTenantSlug } from '../utils/runtime-config';
import de from './de';
import en from './en';
import fr from './fr';
import es from './es';
import nl from './nl';
import pl from './pl';
import sv from './sv';
import it from './it';
import pt from './pt';

export const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'es', 'nl', 'pl', 'sv', 'it', 'pt'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const defaultLocale: SupportedLocale = 'de';
// The person's language, as every app on this origin stores it (issue 673).
export function storedLocale(): SupportedLocale | null {
  return readStoredLocale(SUPPORTED_LOCALES, currentTenantSlug());
}
const locale: SupportedLocale = storedLocale() ?? defaultLocale;

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  messages: mergeAppKitMessages({ de, en, fr, es, nl, pl, sv, it, pt }),
});

export function setLocale(next: string) {
  const value: SupportedLocale = (SUPPORTED_LOCALES as readonly string[]).includes(next)
    ? (next as SupportedLocale)
    : defaultLocale;
  i18n.global.locale.value = value;
  writeStoredLocale(value);
}

/** Show a language read back from storage, without writing it again. */
export function applyStoredLocale(next: string) {
  if ((SUPPORTED_LOCALES as readonly string[]).includes(next)) i18n.global.locale.value = next as SupportedLocale;
}
